<div class="notes-listing">
    <ng-container *ngIf="!currentNote">

        <!-- Botón "+ Agregar nota" -->
        <div *ngIf="!showCreateForm" class="mb-4" (click)="toggleCreateForm()">
            <div class="bg-gray-50 create-note" style="border-radius: 12px;">
                <div class="create-note__title">
                    {{ 'player.footer.notes.create' | translate }}
                </div>
            </div>
        </div>

        <!-- Formulario de nueva nota -->
        <div *ngIf="showCreateForm"
            class="rounded-xl border p-3 flex items-center gap-3 mb-4"
            style="background: color-mix(in hsl, var(--secondary-100) 75%, var(--secondary-200) 10%); border-color: rgb(255, 217, 223);">
            <input
                type="text"
                [value]="newNoteName"
                (input)="newNoteName = $any($event.target).value"
                (keyup.enter)="createNote()"
                placeholder="{{ 'player.note.title' | translate }}"
                class="flex-1 rounded-md text-sm outline-none border-0"
                style="color: #22304C; background: #fff; padding: 0.5rem 0.75rem;"
                autofocus />
            <button
                (click)="toggleCreateForm()"
                class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors"
                style="color: #5F6877;"
                aria-label="Cancelar">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" x2="6" y1="6" y2="18"></line>
                    <line x1="6" x2="18" y1="6" y2="18"></line>
                </svg>
            </button>
            <a class="btn btn_color_green flex-shrink-0"
                style="font-size: 12px; padding: .5rem 1rem; min-width: 0;"
                (click)="createNote()">
                {{ 'player.footer.notes.create' | translate }}
            </a>
        </div>

        <!-- Lista de notas -->
        <div class="space-y-2">
            <div
                *ngFor="let note of notes"
                class="flex items-center justify-between gap-3 rounded-xl border px-4 py-3 transition-colors"
                style="border-color: #E8EAEF; background: #fff; cursor: default;"
                onmouseover="this.style.background='#F6F7F9'" onmouseout="this.style.background='#fff'">

                <p class="text-sm truncate" style="color: #22304C; flex: 1; min-width: 0;">
                    <span class="font-semibold" [innerHtml]="note.name || ('player.note.title' | translate)"></span>
                    <span style="color: #5F6877;"> - {{ note.updated_at | date:'MM/dd/yy HH:mm' }}</span>
                </p>

                <div class="flex items-center gap-2 flex-shrink-0">
                    <!-- Editar -->
                    <button
                        (click)="setCurrentNote(note)"
                        aria-label="Editar"
                        class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors"
                        style="color: #5F6877; border: 1px solid transparent;"
                        onmouseover="this.style.color='var(--v2-color-secondary-500)'; this.style.background='#fff'; this.style.borderColor='var(--v2-color-secondary-500)'"
                        onmouseout="this.style.color='#5F6877'; this.style.background='transparent'; this.style.borderColor='transparent'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4">
                            <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                            <path d="m15 5 4 4"></path>
                        </svg>
                    </button>
                    <!-- Eliminar -->
                    <button
                        (click)="deleteNote(note)"
                        aria-label="Eliminar"
                        class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors"
                        style="color: #5F6877; border: 1px solid transparent;"
                        onmouseover="this.style.color='var(--v2-color-secondary-500)'; this.style.background='#fff'; this.style.borderColor='var(--v2-color-secondary-500)'"
                        onmouseout="this.style.color='#5F6877'; this.style.background='transparent'; this.style.borderColor='transparent'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4">
                            <path d="M3 6h18"></path>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                            <line x1="10" x2="10" y1="11" y2="17"></line>
                            <line x1="14" x2="14" y1="11" y2="17"></line>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

    </ng-container>

    <msc-note-detail
        [note]="currentNote"
        (deleteSelectedNote)="deleteNote($event)"
        (editor)="resetCurrentNote()"
        *ngIf="currentNote">
    </msc-note-detail>
</div>

<style>
    msc-note-detail {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0 1rem;
    }
    @media (max-width: 1024px) {
        msc-note-detail {
            overflow: hidden;
        }
    }
</style>
